import { api } from "..";
import { NewUser } from "../../../types/ApiResponses/User";
import { MaintenanceMode } from "./types";

export interface UpdateMyMaintenancePayload {
  mode: MaintenanceMode;
  enabled: boolean;
  startAt: string | null;
  endAt: string | null;
  message: string;
}

export async function updateMyMaintenance(
  payload: UpdateMyMaintenancePayload
): Promise<NewUser> {
  const res = await api.client.put("/app-settings/me/maintenance", payload);
  return res.data;
}
